import React from "react"
import styles from "./cardChat.module.css"
import { MdOutlineCalendarToday } from "react-icons/md"
import moment from "moment"
import FormGroup from "../../../Form/FormGroup"
import FormGroupExpand from "../../../Form/FormGroupExpand"
import { listAssignTo } from "../../../../schemas/Chat"
import { adjustTextByIndentation, getNameUserById, getPropertyForItemInArrayById } from "../../../../utils/utils"
import { NavLink } from "react-router-dom"
import Button from "../../../Form/Button"
import Message from "../../../Chat/Message"
import DivisionMessage from "../../../Chat/DivisionMessage"

const platforms = [
    { id: "whatsapp", value: "WhatsApp" },
    { id: "whatsapp_api", value: "WhatsApp API" },
]

const CardChat = ({ data = {}, listUsers = [], teams = [], roles = [] }) => {
    const { _id, messages = [], hasNewMessages, contacts = [], defaultPicture, platform, inbox_name, owner, account_id, created_at } = data

    const getResponsiblesByConversation = (owner) => {
        let content = ""
        if (owner?.assignTo === "teamAndRole") {
            content = `- **Equipe**: ${getPropertyForItemInArrayById(owner?.team_id, teams, "id", "value")}\n- **Cargo**: ${getPropertyForItemInArrayById(owner?.role_id, roles, "id", "value")}`
        } else if (owner?.assignTo === "users") {
            const usersNames = owner?.users?.map(user => getNameUserById(listUsers, user?.user_id)).join(", ")
            content = `- **Responsáveis**: ${usersNames}`
        }
        return adjustTextByIndentation(`- **Atribuído para**: ${getPropertyForItemInArrayById(owner?.assignTo, listAssignTo, "id", "value")}\n${content}`)
    }

    return (
        <div className={styles.card}>
            <div className={`${styles.header} ${styles.bottomBorder}`}>
                <div className={styles.left}>
                    <span>Plataforma: </span><span className={styles.name}>{getPropertyForItemInArrayById(platform, platforms, "id", "value") || "-"}</span>
                </div>
                <div className={styles.right}>
                    <MdOutlineCalendarToday />
                    <span>{created_at ? moment(created_at).format("DD/MM/YYYY HH:mm:ss") : "xx/xx/xxxx xx:xx"}</span>
                </div>
            </div>
            <div className={`${styles.body} ${styles.bottomBorder}`}>
                <div className={styles.content}>
                    <FormGroupExpand labelText={<span className={styles.title}>Atribuição</span>} startShow={true}>
                        <div className={styles.description}>{getResponsiblesByConversation(owner)}</div>
                    </FormGroupExpand>
                    <FormGroupExpand labelText={<span className={styles.title}>Caixa de Entrada</span>} startShow={true}>
                        <div className={styles.description}>{adjustTextByIndentation(inbox_name) || ''}</div>
                    </FormGroupExpand>
                    <FormGroupExpand labelText={<span className={styles.title}>Últimas Mensagens</span>} startShow={true}>
                        <div className={styles.messages}>
                            {messages?.length > 0 ? (
                                <>
                                    <DivisionMessage
                                        text={hasNewMessages ? "Para visualizar mensagens mais antigas acesse o Oktto Chat" : "Início das mensagens"}
                                    />
                                    {messages.map((message, index) => (
                                        <Message
                                            key={message._id || message.message_id || index}
                                            message={message}
                                            platform={platform}
                                            contacts={contacts}
                                            lastMessage={messages[index - 1]}
                                            defaultPicture={defaultPicture}
                                            showActions={false}
                                        />
                                    ))}
                                    <DivisionMessage
                                        text={"Fim das mensagens"}
                                    />
                                </>
                            ) :
                                <DivisionMessage
                                    text="Nenhuma mensagem encontrada!"
                                />
                            }
                        </div>
                    </FormGroupExpand>
                    <FormGroup>
                        <NavLink className={`${styles.button}`} to={`/${account_id}/chat/${_id}`} target="_blank">
                            <Button variant="accent" className="gray-dark">Abrir no Oktto Chat</Button>
                        </NavLink>
                    </FormGroup>
                </div>
            </div>
        </div >
    )
}

export default CardChat